<p>restore-password works!</p>
